/**
 * Created by Ning Jiang on 11/24/2016.
 */
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";


export class TeslaSoundConfig implements ISoundConfig {

    public static instance:TeslaSoundConfig = new TeslaSoundConfig();
    AS_WIN:string="asWin";
    AS_WIN_BIG:string="asWinBig";

    MAIN_GAME_AMBIANCE:string = "background-music-main";

    FREESPIN_BG_MUSIC:string = "background-music-fs";

    REEL_NEAR_WIN:string = "anticipation";
    REEL_NEAR_WIN_FAIL:string = "anticipationFail";

    REELS_SPINNING:string = "reelsSpinning";
    REELS_DEFAULT_BOUNCE:string[] = ["reelLanding1", "reelLanding2", "reelLanding3", "reelLanding4", "reelLanding5"];


    SCATTER_ATTENTION:string = "scatterAttention";
    SCATTER_WIN:string = "scatterWin";
    FS_INTRO_CABLE_LIGHTNING:string = "fsIntroCableLightning";
    FS_INTRO_COIL_LIGHTNING:string = "fsIntroCoilLightning";
    FS_INTRO_SWITCH_DOWN:string = "fsIntroHandleDown";
    FS_INTRO_LOGO_EXPLODE:string = "fsIntroLogoExplode";
    FS_INTRO_PANEL_UP:string = "fsIntroPanelUp";
    FS_INTRO_PANEL_COVER:string = "fsPanelCover";
    FS_INTRO_BALL_UP:string = "fsIntroBallUp";
    FS_INTRO_BALL_LANDING:string = "fsIntroBallLanding";
    FS_INTRO_NUMBER:string = "fsIntroNumber";
    FS_INTRO_PAPER:string = "fsIntroPaper";
    FS_ENDS:string = "fsEnds";
    FS_BONUS_LAND:string = "fsBonus";
    FS_WILD_BOUNCE:string = "fsWildHitsBall";
    FS_WILD_RELEASE:string = "fsBallTurnWild";
    FS_UPDATE_SPINS:string = "fsUpdateSpins";

    IDLE_JOLT:string = "idle-jolt";

    BIG_WIN_SMALL:string = "bigWinSmall";
    BIG_WIN_MEDIUM:string = "bigWinMedium";
    BIG_WIN_LARGE:string = "bigWinLarge";
    BIG_WIN_END:string = "bigWinEnds";

    BONUS_SYMBOL_HIGHLIGHT_1:string = "bonusSymbolHighlight1";
    BONUS_SYMBOL_HIGHLIGHT_2:string = "bonusSymbolHighlight2";
    BONUS_SYMBOL_HIGHLIGHT_3:string = "bonusSymbolHighlight3";

    LARGE_WIN:string = "win-large";
    MEDIUM_WIN:string = "win-medium";
    SMALL_WIN:string = "win-small";
    TINY_WIN:string = "win-tiny";
    WILD_ATTENTION:string = "wildAttention";
    COUNT_UP:string = "countup";
    COUNT_UP_END:string = "countup-ends";

    BONUS_BALL_LANDING:string = "bonusBallLanding";
    BONUS_BALL_LIGHTNING:string = "bonusBallLightning";

    BUTTON:string = "button";


    constructor() {
        if(TeslaSoundConfig.instance) {
            throw new Error("TeslaSoundConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}